import Vue from 'vue'
import Vuex from 'vuex'
import Login from './modules/Login.js';

Vue.use(Vuex)

export default new Vuex.Store({
  modules:{
    Login,
  },
  state: {
    loading: false
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {

  }
})
